import { useMemo } from "react";
import { getRouteApi } from "@tanstack/react-router";
import { ClientStatus, FamilySource } from "creso-core/types";
import { useFamilyAum, useFamilyMonthlySip } from "creso-core/hooks";
import { OverviewSection } from "@crm/components/overview/overview-section";
import { AumSummaryCard } from "./family-aum-section";
import { MonthlySipSummaryCard } from "./family-monthly-sip-section";

export function FamilyOverviewMetrics({ source }: { source: FamilySource }) {
  const route = getRouteApi("/(auth)/_headed/clients/families/$id");
  const { family } = route.useLoaderData();
  const { data: aumSummary } = useFamilyAum(family.id, source);
  const { data: sipSummary, isLoading: isSipSummaryLoading } =
    useFamilyMonthlySip(family.id);

  const clientStatusById = useMemo(() => {
    const map = new Map<number, ClientStatus>();
    (family.members ?? []).forEach((member) => {
      map.set(member.client_id, member.status);
    });
    return map;
  }, [family.members]);

  return (
    <OverviewSection
      defaultOpen
      header={
        <div className="grid grid-cols-1 items-center gap-5 lg:grid-cols-2">
          <span className="text-base font-semibold">AUM</span>
          <span className="text-base font-semibold">Monthly SIP</span>
        </div>
      }
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <AumSummaryCard
          overview={aumSummary}
          source={source}
          clientStatusById={clientStatusById}
        />
        <MonthlySipSummaryCard
          overview={sipSummary}
          isLoading={isSipSummaryLoading}
        />
      </div>
    </OverviewSection>
  );
}
